/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Vam_RangeInputs */

const en_exp_vam_range = /** @type {(inputs: Exp_Vam_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Counts the highlighted climbs only, over moving time. A climb starts at 15 % for runs and 5 % for rides. Brisk hiking: around 500 m/h. Strong uphill running or a good amateur on a long bike climb: 1,000 m/h and more.`)
};

const de_exp_vam_range = /** @type {(inputs: Exp_Vam_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zählt nur die markierten Anstiege, in Bewegungszeit. Ein Anstieg beginnt beim Laufen ab 15 %, auf dem Rad ab 5 %. Zügiges Wandern: rund 500 m/h. Starkes Berglaufen oder ein guter Hobbyfahrer am langen Anstieg: 1.000 m/h und mehr.`)
};

/**
* | output |
* | --- |
* | "Counts the highlighted climbs only, over moving time. A climb starts at 15 % for runs and 5 % for rides. Brisk hiking: around 500 m/h. Strong uphill running ..." |
*
* @param {Exp_Vam_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_vam_range = /** @type {((inputs?: Exp_Vam_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Vam_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_vam_range(inputs)
	return de_exp_vam_range(inputs)
});